<template>
  <div class="a-gallery-description">
    <div class="a-gallery-description__about">
      <h2
        ref="gallery-about-heading"
        class="a-gallery-description__heading-about"
      >
        {{ aboutHeadingText }}
      </h2>
      <div class="a-gallery-description__about-text">
        <RichText
          v-if="gallery.description"
          class="a-gallery-description__description"
          :content="gallery.description"
        />
      </div>
    </div>

    <RecordMetadataField
      v-for="(value, key) in metadata"
      :key="key"
      ref="gallery_metadata-field"
      :label="translate(key)"
      :values="value"
    />

    <div
      v-if="gallery?.currentExhibitions?.length"
      class="a-gallery-description__exhibition"
    >
      <h3
        ref="gallery-exhibition-heading"
        class="a-gallery-description__heading-exhibition"
      >
        {{ exhibitionHeadingText }}
      </h3>

      <div
        v-for="exhibition in gallery.currentExhibitions"
        :key="exhibition.id"
        class="a-gallery-description__current_exhibition"
      >
        <div class="a-gallery-description__exhibition-name">
          {{ exhibition.title }}
        </div>
        <div
          v-if="exhibition.place"
          class="a-gallery-description__exhibition-text"
        >
          {{ exhibition.place }}
        </div>
        <div class="a-gallery-description__exhibition-text">
          {{ exhibition.timespan }}
        </div>
        <GuiLink
          class="a-gallery-description__exhibition-link"
          :to="getExhibitionRoute(exhibition)"
        >
          {{ exhibitionLinkText }}
        </GuiLink>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GuiLink,
  RecordMetadataField,
  RichText,
  useLocalization
} from "@thegetty-private/getty-ui";
import { getIndexedId } from "@thegetty-private/rad-app-utils";
import { getObjectDescription } from "@thegetty-private/linked-data.js";

export default {
  name: "GalleryDescription",

  components: {
    GuiLink,
    RecordMetadataField,
    RichText
  },

  props: {
    /**
     * The gallery object's LOD
     */
    gallery: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  computed: {
    /**
     * The heading for the Gallery details (map) section
     * @return {string}
     */
    aboutHeadingText() {
      return this.translatePart("gallery_page.about");
    },
    currentExhibitions() {
      return this.currentExhibitionsById(this.gallery.id);
    },
    /**
     * The heading for the Current Exhibition section
     * @return {string}
     */
    exhibitionHeadingText() {
      return this.translatePart("gallery_page.current_exhibitions");
    },
    /**
     * Gets the translated link text for an exhibition link (if applicable)
     *
     * @returns {string}
     */
    exhibitionLinkText() {
      return this.translatePart("gallery_page.exhibition_link");
    },
    /**
     * The description
     * @returns {string}
     */
    description() {
      if (this.gallery == undefined) {
        return;
      }
      return getObjectDescription(this.gallery, "text/markdown");
    },
    /**
     * Returns the metadata object for the gallery
     */
    metadata() {
      let metadata = {};

      if (this.gallery.floor) {
        metadata["gallery_metadata.floor"] = this.gallery.floor;
      }
      if (this.gallery.room) {
        metadata["gallery_metadata.room"] = this.gallery.room;
      }
      return metadata;
    }
  },
  methods: {
    /**
     * Builds the exhibition route object
     *
     * @returns {object} - a route object
     */
    getExhibitionRoute(exhibition) {
      return {
        name: "exhibition",
        state: {
          indexedId: getIndexedId(exhibition.id),
          slug: exhibition.slug
        },
        params: {
          slug: exhibition.slug
        }
      };
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
